module.exports = __webpack_public_path__ + "img/custom-reviews.fe033d16.png";